// =============================================================================
// src/features/analytics/analytics-block-store.ts - Bloqueio de autor (curadoria).
//
// Ponte entre o botao "Bloquear autor" do feed e a mutation do Hasura
// (sl_insert_config_author_blocklist_one): o composition root registra o
// submitter quando o live esta habilitado; o controller consome sem conhecer
// transporte. Sem submitter (mock/offline) o resultado é 'unavailable' e o
// botao vira o toast cosmetico de sempre. SRP: so o registro + despacho.
// =============================================================================

export interface AnalyticsAuthorBlockRequest {
  readonly platform: string;
  readonly authorHandle: string;
  readonly reason: string;
}

export type AnalyticsAuthorBlockOutcome = 'blocked' | 'failed' | 'unavailable';

type AnalyticsAuthorBlockSubmitter = (blockRequest: AnalyticsAuthorBlockRequest) => Promise<void>;

let authorBlockSubmitter: AnalyticsAuthorBlockSubmitter | null = null;

/** Registrado pelo main.ts quando o Analytics live esta habilitado. */
export function setAnalyticsAuthorBlockSubmitter(submitter: AnalyticsAuthorBlockSubmitter): void {
  authorBlockSubmitter = submitter;
}

/** Envia o bloqueio; nunca lança (o controller decide o toast pelo outcome). */
export async function submitAnalyticsAuthorBlock(
  blockRequest: AnalyticsAuthorBlockRequest,
): Promise<AnalyticsAuthorBlockOutcome> {
  if (!authorBlockSubmitter) return 'unavailable';
  try {
    await authorBlockSubmitter(blockRequest);
    return 'blocked';
  } catch {
    return 'failed';
  }
}

export function __resetAnalyticsAuthorBlockForTests(): void {
  authorBlockSubmitter = null;
}
